import React from "react";
import SEOHead from "../components/tools/SEOHead";
import MarketingShell, { useMarketingCopy } from "./MarketingShell";
import founderCopy from "./founderStoryCopy.json";
import "./FounderPage.css";

export default function FounderPage() {
  const { language } = useMarketingCopy();
  const copy = founderCopy[language] ?? founderCopy.en;

  return <MarketingShell active="story">
    <SEOHead title={copy.seoTitle} description={copy.lead} canonicalUrl="https://youwo.ai/founder"
      ogImage="https://youwo.ai/brand/founder-shonn-li-x-2026.jpg"
      structuredData={{ "@context": "https://schema.org", "@type": "AboutPage", name: copy.seoTitle, description: copy.lead, url: "https://youwo.ai/founder", mainEntity: { "@type": "Person", name: "Shonn Li", sameAs: ["https://x.com/shonn_li"], worksFor: { "@type": "Organization", name: "YouWo", url: "https://youwo.ai" } } }} />
    <main id="main-content" tabIndex={-1} className="founder-page">
      <header className="quant-wrap founder-hero">
        <div className="founder-hero-copy">
          <p className="narrative-label">{copy.label}</p>
          <h1>{copy.title}<br /><em>{copy.accent}</em></h1>
          <p>{copy.lead}</p>
        </div>
        <figure className="founder-hero-figure">
          <div className="founder-portrait"><img src="/brand/founder-shonn-li-x-2026.jpg" width="400" height="400" alt={copy.portraitAlt} decoding="async" /></div>
          <figcaption>{copy.visualCaption} · <a href="https://x.com/shonn_li" target="_blank" rel="noopener noreferrer">{copy.profileLink}</a></figcaption>
        </figure>
      </header>

      <section className="quant-wrap founder-origin" aria-labelledby="founder-origin-title">
        <div><p className="narrative-label">{copy.originLabel}</p><h2 id="founder-origin-title">{copy.originTitle}</h2></div>
        <div className="founder-prose">{copy.origin.map(paragraph => <p key={paragraph}>{paragraph}</p>)}</div>
      </section>

      <section className="quant-wrap founder-turns" aria-labelledby="founder-turns-title">
        <div><p className="narrative-label">{copy.turnLabel}</p><h2 id="founder-turns-title">{copy.turnTitle}</h2></div>
        <ol>{copy.turns.map((turn, index) => <li key={turn.title}><span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span><h3>{turn.title}</h3><p>{turn.text}</p></li>)}</ol>
      </section>

      <section className="founder-belief" aria-labelledby="founder-belief-title"><div className="quant-wrap">
        <p className="narrative-label">{copy.beliefLabel}</p><h2 id="founder-belief-title">{copy.beliefTitle}</h2><p>{copy.belief}</p>
      </div></section>

      <section className="quant-wrap founder-future" aria-labelledby="founder-future-title">
        <div><p className="narrative-label">{copy.futureLabel}</p><h2 id="founder-future-title">{copy.futureTitle}</h2></div>
        <div><p>{copy.future}</p><nav aria-label={copy.futureLabel}><a className="quant-text-link" href="/story">{copy.companyLink}</a><a className="quant-text-link" href="/mission">{copy.missionLink}</a></nav></div>
      </section>
    </main>
  </MarketingShell>;
}
